import PropTypes from 'prop-types';
import React from 'react';
import DefaultHeader from '../../../containers/layout/DefaultHeader';
import DefaultFooter from '../../../containers/layout/DefaultFooter';
import Page from '../Page';

const DefaultPage = ({ children }) => (
  <Page
    header={
      <DefaultHeader />
    }
    main={children}
    footer={
      <DefaultFooter />
    }
  />
);

DefaultPage.propTypes = {
  children: PropTypes.node.isRequired
};

export default DefaultPage;
